
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/order-confirmation",
      function () {
        return require("private-next-pages/design-system/order-confirmation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/order-confirmation"])
      });
    }
  